import { Component } from '@angular/core';

@Component({
  selector: 'app-toolbar-share',
  templateUrl: './toolbar-share.component.html',
  styleUrls: ['./toolbar-share.component.styl']
})
export class ToolbarShareComponent {
  popupIsDisplayed = false;

  onButtonClick() {
    this.popupIsDisplayed = !this.popupIsDisplayed;
  }
}



// WEBPACK FOOTER //
// ./src/app/rec/components/toolbar/toolbar-share/toolbar-share.component.ts